<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <div class="btn-group" role="group" aria-label="basic">
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('PorVencer')">Por Vencer</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('PorFecha')">Por Fecha</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('Todos')">Todos</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('Cobradas')">Cobradas</button>
                    </div>
                </div>
                <Transition>
                    <div class="form-inline" v-show="BotonMenu.PorFecha">
                        <div class="row form-group">
                            <div class="col-lg-4">
                                <label for="">Fecha Inicial</label>
                                <Datepicker @input="Lista" v-model="Filtro.FechaFiltro.Inicio" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                            </div>
                            <div class="col-lg-4">
                                <label for="">Fecha Final</label>
                                <Datepicker @input="Lista" v-model="Filtro.FechaFiltro.Fin" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                            </div>
                        </div>
                    </div>
                </Transition>
            </template>

            <template slot="AntTabla">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-12">
                            <h3>Datos del Cliente</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3">
                            <span class="bold text-black">Razón Social:</span> <span>{{ ObjCliente.RazonSocial }}</span>
                        </div>
                        <div class="col-lg-3">
                            <span class="bold text-black">Nombre Comercial:</span> <span>{{ ObjCliente.NombreComercial }}</span>
                        </div>
                        <div class="col-lg-3">
                            <span class="bold text-black">Email:</span> <span>{{ ObjCliente.Email }}</span>
                        </div>
                        <div class="col-lg-3">
                            <span class="bold text-black">Teléfono:</span> <span>{{ ObjCliente.Telefono }}</span>
                        </div>
                    </div>
                </div>
            </template>
            
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Folio de Nota / Folio Factura</th>
                <th :class="StyleTh">Importe</th>
                <th :class="StyleTh">Fecha de Facturación</th>
                <th :class="StyleTh">Fecha de Pago</th>
                <th :class="StyleTh">Estatus</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>

            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><p :class="StyleTd">{{lista.Folio}}</p></td>
                    <td><p :class="StyleTd">$ {{lista.TotalPago}}</p></td>
                    <td><p :class="StyleTd">{{lista.nota_ventas!=undefined ? $getCleanDate(lista.nota_ventas.Fecha,false) : $getCleanDate(lista.facturas.FechaTimbrado,false)}}</p></td>
                    <td><p :class="StyleTd">{{$getCleanDate(lista.FechaPago,false)}}</p></td>
                    <td><p :class="StyleTd">{{lista.Estatus != 'Pagado' && EstaVencida(lista.FechaPago) ? 'Vencida' : lista.Estatus}}</p></td>
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="lista.Estatus != 'Pagado' ? true : false" :pShowBtnDelete="false" :pIsModal="true" :pId="lista.IdCuentaCobrar" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
                            <template slot="btnaccion">
                                <CMoreButtonsL>
                                    <template slot="bodyBtnsL">
                                        <li @click="CobrarCuenta(lista.IdCuentaCobrar,lista)">
                                            <a class="dropdown-item">
                                                <div v-show="lista.Estatus=='Pendiente'">
                                                    <i class="far fa-hand-holding-usd"></i> Cobrar
                                                </div>
                                                <div v-show="lista.Estatus=='Pagado'">
                                                    <i v-show="lista.Estatus=='Pagado'" class="far fa-eye"></i> Observaciones
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item">
                                                <i class="far fa-file-pdf"></i> Ver Pdf
                                            </a>
                                        </li>
                                    </template>
                                </CMoreButtonsL>
                            </template>
                        </CBtnAccion>
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="7"></CSinRegistros>
            </template>

        </CList>
        
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave" :pListaCuentasCobrar="ListaSimple"></Form>
			</template>
		</CModal>

        <CModal :pConfigModal="ConfigModalCobrar" :poBtnSave="oBtnSaveCobrar">
			<template slot="Form">
				<FormCobrar :poBtnSave="oBtnSaveCobrar"></FormCobrar>
			</template>
		</CModal>
    </div>
</template>

<script>
import moment from 'moment';
import Calendar from '@/helpers/StaticComboBox.js';
import Form from './Form.vue';
import FormCobrar from './Cobrar.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionCuentasCobrar';
const EmitEjecuta2='seccionCobrar';
export default {
    name:'ListaCuentasCobrar',
    props:['pOrigen','pObjCliente'],
    components:{Form,FormCobrar},
    data() {
        return {
            ConfigList:{
                Title: 'Cuentas de ',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Cuentas Por Cobrar',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                Estatus:'',
                FechaFiltro:{
                    Inicio:'',
                    Fin:''
                },
                IdCliente:''
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Cuentas Por Cobrar",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize:'lg'
            },
            oBtnSave:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            ConfigModalCobrar:{
                ModalTitle: "Cobrar",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
            },
            oBtnSaveCobrar:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
                ShowBtnSave:true
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],
            ListaSimple:[],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Setpicker:Calendar.calendarSettings,
            UrlApi:'',
            Tipo:'',
            BotonMenu:{
                PorVencer:true,
                PorFecha:false,
                Todos:false,
                Cobradas:false
            },
            ObjCliente:{}
        }
    },
    methods: {
        async Lista(){
            this.ListaArrayRows=[];
            this.UrlApi='/cuentaPorCobrar'
            this.Filtro.Estatus='Pendiente';
            this.Tipo='';
            let params={
                TxtBusqueda:this.Filtro.Nombre,
                Entrada:this.Filtro.Entrada,
                Pag:this.Filtro.Pagina,
                Estatus:this.Filtro.Estatus,
                Tipo:this.Tipo,
                IdCliente:this.Filtro.IdCliente
            }
            if (this.BotonMenu.PorVencer) {
                this.Tipo='PorVencer';
                this.Filtro.Estatus='Pendiente';
                params.Tipo=this.Tipo;
                params.Estatus=this.Filtro.Estatus;
            }
            if (this.BotonMenu.PorFecha) {
                params.FechaInicio='';
                params.FechaFin='';
                if (this.Filtro.FechaFiltro.Inicio!='') {
                    let YearInicio=this.Filtro.FechaFiltro.Inicio.getFullYear();
                    let MonthInicio=this.Filtro.FechaFiltro.Inicio.getMonth()+1;
                    let DayInicio=this.Filtro.FechaFiltro.Inicio.getDate();
                    params.FechaInicio=YearInicio+'-'+MonthInicio+'-'+DayInicio;
                }
                if (this.Filtro.FechaFiltro.Fin!='') {
                    let YearFin=this.Filtro.FechaFiltro.Fin.getFullYear();
                    let MonthFin=this.Filtro.FechaFiltro.Fin.getMonth()+1;
                    let DayFin=this.Filtro.FechaFiltro.Fin.getDate();
                    params.FechaFin=YearFin+'-'+MonthFin+'-'+DayFin;
                }

                this.Tipo='PorFecha';
                this.Filtro.Estatus='Pendiente';
                params.Tipo=this.Tipo;
                params.Estatus=this.Filtro.Estatus;
            }
            if (this.BotonMenu.Cobradas) {
                this.Tipo='Cobradas'
                this.Filtro.Estatus='Pagado';
                params.Tipo=this.Tipo;
                params.Estatus=this.Filtro.Estatus;
            }
            this.ConfigList.ShowLoader = true;
            this.$http.get(this.UrlApi,{
                params:params
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            })
        },
        Regresar(){
            this.$router.push({name:'cuentaporcobrar',params:{}});
        },
        GetListaSimple(){
            this.$http.get("/cuentaPorCobrarSimple"
            ).then((res)=>{
                this.ListaSimple=res.data.data;
            })
        },
        SeleccionLista(index){
            this.Filtro.FechaFiltro.Inicio='';
            this.Filtro.FechaFiltro.Fin='';
            let BotonMenu=this.BotonMenu;
            Object.keys(BotonMenu).forEach(function(key,ind){
				if (key==index) {
					BotonMenu[key]=true;
				}
				else{
					BotonMenu[key]=false;
				}
				// console.log(index)
			});
            this.Lista();
        },
        CobrarCuenta(index,item){
            this.oBtnSaveCobrar.ShowBtnSave=item.Estatus!='Pagado' ?  true : false;
            this.bus.$emit('NewModal_'+this.ConfigModalCobrar.EmitSeccion,index);
        },
        EstaVencida(FechaAEvaluar){
            let formatedDate = FechaAEvaluar.replace(/-/g, "\/");
            let FechaCuenta=new Date(formatedDate);
            let FechaActual=new Date();
            if (FechaActual.getTime()>FechaCuenta.getTime()) {
                return true; 
            }
            else{
                return false;
            }
        }
    },
    created() {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }
        if (this.pObjCliente!=undefined) {
            sessionStorage.setItem('cliente',JSON.stringify(this.pObjCliente));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        this.ObjCliente=JSON.parse(sessionStorage.getItem('cliente'));
        this.ConfigList.Title='Cuentas de '+this.ObjCliente.NombreComercial;
        this.Filtro.IdCliente=this.ObjCliente.IdCliente;

        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('ListaSimple');
        this.bus.$off('EmitReturn');
        this.GetListaSimple();
    },
    mounted() {
        this.Lista();
        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('ListaSimple',()=>
        {
            this.GetListaSimple();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>